import * as yup from 'yup';

export const OrderSummarySchema = yup.object({
  exit_status: yup.number(),
  orders: yup.array().of(
    yup.object({
      id: yup.number(),
      uuid: yup.string(),
      status: yup.number(),
      priority: yup.number(),
      client_org: yup.string().nullable(),
      solar_farm_uuid: yup.string().nullable(),
      solar_farm_name: yup.string().nullable(),
      order_type: yup.string().nullable(),
      id_report_provider: yup.string().nullable(),
      color: yup.string().nullable(),
      delivered_tsecs: yup.number().nullable(),
      data_received_tsecs: yup.number().nullable(),
      internal_comments: yup.string().nullable(),
      processing_hold: yup.boolean(),
      turnkey_services: yup.boolean(),
      inspections: yup.array().of(
        yup.object({
          id: yup.number().nullable(),
          uuid: yup.string().nullable(),
          solar_farm_uuid: yup.string().nullable(),
          power_inspected: yup.number().nullable(),
        }),
      ),
    }),
  ),
});

export type OrderSummaryResponse = yup.InferType<typeof OrderSummarySchema>;
export type OrderSummary = OrderSummaryResponse['orders'];
